const $ = jQuery.noConflict();

'use strict';
const ProductsRelated = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domSliderIconWishlist: $('.js-product-box__icon-right-icon').parent().parent().parent().parent().find($('.js-product-box__icon-right-icon')),
	classSwitch: 'switch-icons',

	/** @description Initialize */
	init: function() {
		// this.SliderWishlistIconsSwitch();
		if($('.compare-block__bottom-box').length === 3) {
			$('.compare-block').addClass('compare-block--three');
		} else if($('.compare-block__bottom-box').length === 4) {
			$('.compare-block').addClass('compare-block--four');
		} else {
			$('.compare-block').removeClass('compare-block--three');
			$('.compare-block').removeClass('compare-block--four');
		}
		this.gridListViewChange();
	},

	SliderWishlistIconsSwitch: function() {
		ProductsRelated.$domSliderIconWishlist.each(function(e, el) {
			$(el).on('click', function() {
				$(el).toggleClass(ProductsRelated.classSwitch);
			});
		});
	},

	gridListViewChange: function() {
		$('.js-grid-view').on('click', function() {
			$('.js-grid-view').addClass('is-active');
			$('.js-list-view').removeClass('is-active');
			$('.products-listing__holder-products-wrap').removeClass('is-list-view');
		});
		$('.js-list-view').on('click', function() {
			$('.js-list-view').addClass('is-active');
			$('.js-grid-view').removeClass('is-active');
			$('.products-listing__holder-products-wrap').addClass('is-list-view');
		});
	}
};

export default ProductsRelated;
